export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"https://www.locandasolagna.it/graphql","tokenName":"apollo:default.token","authType":"Bearer","authHeader":"Authorization","tokenStorage":"cookie"}}
}